import { atom } from "@mongez/react-atom";
import { Settings } from "../types";

export const settingsAtom: any = atom<Settings>({
  key: "settings",
  default: {},
});
